"use client";

import React from "react";
import { MessageCircle, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrecisaDeAjudaTecnica() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="225547" id="chamada-final" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-4xl mx-auto">
        <div ref={ref} className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="bg-gradient-to-br from-white to-slate-50 text-foreground border-none shadow-none relative overflow-hidden">
            {}
            <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl pointer-events-none" />

            <CardContent className="p-8 md:p-16 flex flex-col items-center text-center relative z-10">
              <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 text-primary ring-4 ring-primary/5">
                <Wrench className="w-8 h-8" />
              </div>

              <h2 className="text-3xl md:text-4xl font-bold font-default mb-4 tracking-tight text-foreground">
                Pronto para posicionar sua empresa no mercado?
              </h2>

              <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl font-default">
                Transforme sua presença digital com estratégias de design e branding que conectam sua marca ao público certo de forma impactante.
              </p>

              <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base md:text-lg h-14 px-8 rounded-full shadow-xl transition-transform hover:scale-105" asChild>
                <Link to="https://wa.me/5511969100007" newTab>
                  <MessageCircle className="w-6 h-6 mr-2" />
                  Falar com um especialista agora
                </Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}